import { useInfiniteQuery, useQuery } from 'react-query';
import { errorToast } from 'lib/components/toasts/error';
import { EXPRESS_API } from 'configs/api/expressApi';
import { uiKitsKeys } from './uiKitsKeys';
import { DEFAULT_UI_KITS_SIZE } from 'app/pages/admin/landing-pages-v2/components/uikit/UIKit';

export interface IUIKitsQueryParams {
  start?: number;
  limit: number;
  search: string;
}

export interface IUIKit {
  id?: number;
  bodyBackgroundColor: string;
  bodyFontSize: number;
  buttonColor: string;
  createdAt?: string;
  updatedAt?: string;
  fontFamily: string;
  footerBackgroundColor: string;
  headerBackgroundColor: string;
  textColor: string;
  thumbnail: string;
  title: string;
  titleFontSize: number;
}

export interface IUIKitsResponse {
  count: 0;
  data: IUIKit[];
}

const getUIKits = async (
  props: IUIKitsQueryParams
): Promise<IUIKitsResponse> => {
  const params = {
    limit: props.limit,
    search: props.search,
    start: props.start,
  };

  return (
    await EXPRESS_API.get(`/superadmin/uikit`, {
      params,
    })
  ).data;
};

export const useQueryUIKits = (
  params: IUIKitsQueryParams,
  enabled: boolean = true
) => {
  return useQuery(
    uiKitsKeys.list({
      start: params.start,
      limit: params.limit,
      search: params.search || '',
    }),
    () => getUIKits(params),
    {
      refetchOnMount: true,
      staleTime: 0,
      enabled,
      onError: () => {
        errorToast({
          title: "We're currently experiencing difficulties fetching UI Kits",
        });
      },
    }
  );
};

export const useInfiniteUIKitsQuery = (params: IUIKitsQueryParams) => {
  return useInfiniteQuery(
    uiKitsKeys.list(params),
    ({ pageParam = 0 }) =>
      getUIKits({ ...params, start: pageParam * DEFAULT_UI_KITS_SIZE }),
    {
      refetchOnMount: true,
      getNextPageParam: (_, allPages) => {
        return allPages.length;
      },
      onError: () => {
        errorToast({
          title: "We're currently experiencing difficulties fetching UI Kits",
        });
      },
    }
  );
};
